import React from 'react';
import styles from "../Services2/Services2.module.scss";
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import ki from '../../../assets/Images/team_2020/Krishna_Ojha.jpg';
import ei from '../../../assets/Images/team_2020/Ekta_Arora.jpeg';
import hi from '../../../assets/Images/team_2020/Himanshu_Kumar.jpg';
import vi from '../../../assets/Images/team_2020/Vikas_Choudhary.png';
import sj from '../../../assets/Images/team_2020/Sonakshi_Jhanwar.jpg';
import dp from '../../../assets/Images/team_2020/Dhairya_Patel.jpeg';
import ag from '../../../assets/Images/team_2020/Aakash_Gavle.jpg';
import sa from '../../../assets/Images/team_2020/Shravya_Ajila.jpg';
import pg from '../../../assets/Images/team_2020/Puneet_Gangwal.jpg';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import style from './Accordion.module.scss';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import THEME from '../../../state/theme';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    stem: {
        width: '300px',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
        transition: '0.3s',
        borderRadius: '5px',
        marginBottom: '30px'

    }
}));

export default () => {
    const classes = useStyles();
    return (
        <>
            <div >
                <div class={styles.container_two} >
                    <div  >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Secretary</p>
                            <div className={styles.wrapper}>
                                <img src={ki} />
                                <ul>
                                    <li> <a href="https://twitter.com/KrishnaOjha02" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/krishnaojha02/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/coder-KO" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                                <h2 className={styles.nameHeading}>Krishna Ojha</h2>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Web Head</p>
                            <div className={styles.wrapper}>
                                <img src={ei} />
                                <h2 className={styles.nameHeading}>Ekta Arora</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/aroraekta351" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/ektaarora3501" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/ektaarora3501" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Event Head</p>
                            <div className={styles.wrapper}>
                                <img src={hi} />
                                <h2 className={styles.nameHeading}>Himanshu Kumar</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/himansh10031744" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/himanshu-kumar-846601193/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/kingslayer07" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div  >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Design Head</p>
                            <div className={styles.wrapper}>
                                <img src={sj} />
                                <h2 className={styles.nameHeading}>Sonakshi</h2>
                                <ul>
                                    {/* <li> <a href="#"> <TwitterIcon /> </a></li> */}
                                    <li> <a href="https://www.linkedin.com/in/sonakshi-jhanwar-302683176" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/Sonakshi16" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Social Media Head</p>
                            <div className={styles.wrapper}>
                                <img src={dp} />
                                <h2 className={styles.nameHeading}>Dhairya</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/AAA__530" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/dhairya-patel530/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/AAA530" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Finance Head</p>
                            <div className={styles.wrapper}>
                                <img src={ag} />
                                <h2 className={styles.nameHeading}>Akash Gavle</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/Aakash_gavle" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/aakash-gavle/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/aakash-gavle" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Corporate Head</p>
                            <div className={styles.wrapper}>
                                <img src={vi} />
                                <h2 className={styles.nameHeading}>Vikas Choudhary</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/_Vikas_007" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/vikas-choudhary-2b848119a/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://github.com/vikaschoudhary007" target="_blank"> <GitHubIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Corporate</p>
                            <div className={styles.wrapper}>
                                <img src={sa} />
                                <h2 className={styles.nameHeading}>Shravya</h2>
                                <ul>
                                    <li> <a href="https://twitter.com/shravyaajila" target="_blank"> <TwitterIcon /> </a></li>
                                    <li> <a href="http://www.linkedin.com/in/shravyaajila" target="_blank"> <LinkedInIcon /> </a></li>
                                    {/* <li> <a href="" target="_blank"> <GitHubIcon />  </a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Marketing Head</p>
                            <div className={styles.wrapper}>
                                <img src={pg} />
                                <h2 className={styles.nameHeading}>Puneet</h2>
                                <ul>
                                    {/* <li> <a href="#"> <TwitterIcon /> </a></li>
                                    <li> <a href="#"> <LinkedInIcon /> </a></li>
                                    <li> <a href="#"> <GitHubIcon />  </a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

                <div>

                    <div className={classes.root}>

                        <Accordion>
                            <div>
                                <div className={style.newcontent}>
                                    <ul className={style.newrow}>
                                        <li>
                                            <AccordionSummary >
                                                <Button className={style.newthing}>
                                                    <span>Main Team </span>
                                                    <i className="las la-long-arrow-alt-right" />
                                                </Button>
                                            </AccordionSummary>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <AccordionDetails>
                                <div className={styles.cardlist} >
                                    <div className={styles.box} >
                                        <List className={classes.stem}>
                                            <h3 style={{ background: "#303030", height: "60px", paddingTop: "17px", fontWeight: "bold", color: "white" }}>Web Team</h3>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Shubham Patidar</p>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Vrutik Rabadia</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}> Yash Wandhare</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Naumanuddin Kazi</p>
                                            </ListItem>
                                        </List>
                                    </div>
                                    <div className={styles.box}>
                                        <List className={classes.stem}>
                                            <h3 style={{ background: "#303030", height: "60px", paddingTop: "17px", fontWeight: "bold", color: "white" }}>Content Writing</h3>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Ritesh Shukla</p>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Shubham Mandon</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Ujjawal</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Avanish Gupta</p>
                                            </ListItem>
                                        </List>

                                    </div>
                                    <div className={styles.box}>
                                        <List className={classes.stem}>
                                            <h3 style={{ background: "#303030", height: "60px", paddingTop: "17px", fontWeight: "bold", color: "white" }}>Design and Editing</h3>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Nishant Singh</p>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Prince Patel</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Suraj Sisodia</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Prakash Kumar</p>
                                            </ListItem>
                                        </List>

                                    </div>
                                    <div className={styles.box}>
                                        <List className={classes.stem}>
                                            <h3 style={{ background: "#303030", height: "60px", color: "white", fontWeight: "bold" }}>Event Planning and Management</h3>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Yash Vadi</p>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Harsh Bunkar</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Raj Bindra</p>

                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar style={{ backgroundColor: THEME.color }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <p style={{ fontSize: "18px" }}>Anish Choudhary</p>
                                            </ListItem>
                                        </List>

                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>

            </div>
        </>
    )
}